<template>
  <div>
    <CDataTable
      class="d-none d-xl-block"
      striped
      small
      :border='false'
      hover
      :loading="isLoading"
      :items="offers"
      :fields="fields"
      :items-per-page="10"
      pagination
      :clickableRows="true"
      @row-clicked="rowClicked"
    >
      <template #loading>
        <div class="text-center">
        <CSpinner color="primary"/>
        </div>
      </template>
      <template #no-items-view>
        <div class="text-center">{{error ? error : "No items"}}</div>  
      </template>
      <template #lot="{item}">
        <td>
          <CBadge :color="item.offerType == 'FIRM' ? 'info' : 'secondary'">{{item.lot}}</CBadge>
        </td>
      </template>
    </CDataTable>

    <CDataTable
      class="d-xl-none"
      striped
      small
      :border='false'
      hover
      :loading="isLoading"
      :items="offers"
      :fields="[{key: 'single', _classes: 'd-none'}]"
      :items-per-page="10"
      pagination
      :clickableRows="true"
      @row-clicked="rowClicked"
    >
      <template #loading>
        <div class="text-center">
        <CSpinner color="primary"/>
        </div>
      </template>
      <template #no-items-view>
        <div class="text-center">{{error ? error : "No items"}}</div>  
      </template>
      <template #single="{item}">
        <OfferCardSmall :offer="item" :showDivider="false" />
      </template>
    </CDataTable>
  </div>
</template>

<script>
import offerAPI from '@/api/offer'
import OfferCardSmall from '@/views/offer/OfferCardSmall'

export default {
  name: 'Offered',
  props: ['sort'],
  components: {
    OfferCardSmall
  },
  data () {
    return {
      isLoading: false,
      error: null,
      offers: [],
      fields: [
        'lot', 
        {key: 'dateCreatedDateOnlyFormatted', label: 'Date', _classes: 'nowrap'}, 
        {key: 'grainLabel', label: 'Grain', _classes: 'strong nowrap'}, 
        {key: 'gradeLabel', label: 'Grade', _classes: 'strong nowrap'}, 
        {key: 'seasonLabel', label: 'Season'},
        {key: 'shortLocatedLabel', label: 'Located'},
        {key: 'storageTypeLabel', label: 'Storage'},
        {key: 'offerTypeLabel', label: 'Type'}, 
        {key: 'quantityRemaining', label: 'Quantity (mt)', _classes: 'strong text-right nowrap'},
        {key: 'priceLabel', label: 'Price / mt', _classes: 'strong text-right nowrap'},
        {key: 'bidPriceSpread', label: 'Best bid', _classes: 'strong text-right nowrap'},
      ],
    }
  },
  async mounted () {
    await this.getOffers()
  },
  methods: {
    async getOffers() {
      this.offers = []
      this.error = null
      this.isLoading = true
      try {
            
        console.log('getOffers: ' + this.orderBy)
        const result = await offerAPI.getOpenOffers({numberOfItems: 20, page: 1, sort: this.sort})
        this.offers = result.data
      } catch (e) { 
        console.error(e)
        this.error = e
      }
      this.isLoading = false
    },
    rowClicked (item, index, columnName, event) {
      this.$router.push({ name: 'SearchOffer', params: { lot: item.lot, offer: item } })
    },
  }
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
}
</style>

<style>
td.strong {
  font-weight: 500;
}
</style>
